import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";

import { authenticate } from "MODULES/session/actions";
import { LargeInput as FormInput, Save } from "MODULES/shared/components/Forms";
import { EMAIL, PASSWORD } from "APP_ROOT/constants";
import api from "APP_ROOT/api";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import AwaitingMfa from "MODULES/session/components/AwaitingMfa/AwaitingMfa";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";

export function Login({ getFieldValue, loginError, pushIds, ...props }) {
  const alert = loginError && (
    <div className="alert alert-danger">{loginError}</div>
  );

  const [tenant, setTenant] = useState({});
  const passwordField = document.querySelector("#password");
  const handleClickPassword = () => {
    const type =
      passwordField.getAttribute("type") === "password" ? "text" : "password";
    passwordField.setAttribute("type", type);
  };

  useEffect(() => {
    api.session.tenant().then(({ data }) => {
      setTenant(data);

      return function cleanup() {};
    });
  }, []);

  const loginStyle = { display: pushIds ? "none" : "block" };

  return (
    <div className="login">
      <div className="container-fluid">
        <div className="main">
          <div className="row">
            <Col md={4} mdOffset={4}>
              <div className="panel panel-default">
                <div className="panel-body">
                  <div className="text-center">
                    {tenant && <img src={tenant.logo_url} alt="Logo" />}
                  </div>
                  <br />
                  <h1
                    className="text-center margin-top-none"
                    style={loginStyle}
                  >
                    Sign in to get started
                  </h1>
                  <form onSubmit={props.handleSubmit} style={loginStyle}>
                    {alert}
                    <Field
                      name="email"
                      component={FormInput}
                      label="Email"
                      required
                    />
                    <Field
                      name="password"
                      component={FormInput}
                      label="Password"
                      addon={
                        <i
                          className="fa fa-fw fa-eye"
                          onClick={handleClickPassword}
                        />
                      }
                      type="password"
                      required
                    />
                    <Link to="/forgot-password">Forgot Password?</Link>
                    <br />
                    <div className="row">
                      <Col md={6} mdOffset={3}>
                        <Save {...props} icon="fa-unlock" text="Sign In" />
                      </Col>
                    </div>
                  </form>
                  {pushIds && (
                    <AwaitingMfa
                      pushIds={pushIds}
                      email={getFieldValue(EMAIL)}
                      password={getFieldValue(PASSWORD)}
                    />
                  )}
                </div>
              </div>
            </Col>
          </div>
        </div>
      </div>
    </div>
  );
}

Login.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loginError: PropTypes.string
};

Login.defaultProps = { loginError: null };

const actions = { onSubmit: authenticate };

const validate = values =>
  validator(values, v => {
    v.validate(EMAIL, PASSWORD).satisfies(rules.required);
  });

const select = state => ({
  loginError: state.session.get("loginError"),
  pushIds: state.session.get("pushId")
});

export default connect(select, actions)(
  reduxForm({
    form: "login",
    validate
  })(withFieldAccessors(Login))
);



// WEBPACK FOOTER //
// ./app/modules/session/components/Login/Login.jsx